import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ALERTS_INCASSO: MijnRoute = {
    path: 'incasso-notificatie',
    navigationEvent: 'toIncassoNotificatie',
    regex: /^\/zelf-regelen\/notificaties-beheren\/incasso-notificatie$/,
    webcomponent: 'mijn-klant-notificatie-beheer-webcomponent',
    internalPath: '/incasso-notificatie'
};
